import { createFileRoute, Outlet } from "@tanstack/react-router";
import { gameContextQueryOptions } from "@/features/game/records";
import { gameResourceSearch } from "@/features/game/addresses";
import {
  GameFrame,
  GamePending,
  GameRouteError,
} from "@/features/game/navigation";

export const Route = createFileRoute("/_site/$coworld")({
  loaderDeps: ({ search }) => ({ resource: gameResourceSearch(search) }),
  shouldReload: ({ cause }) => cause !== "stay",
  loader: async ({ context, location }) => {
    const options = gameContextQueryOptions(location.href);

    void context.queryClient.prefetchQuery(options);
  },
  pendingMs: 0,
  pendingComponent: GamePending,
  errorComponent: GameRouteError,
  component: GameLayout,
});

function GameLayout() {
  return (
    <GameFrame>
      <Outlet />
    </GameFrame>
  );
}
